import { tooltipEmits as N, useTooltipProps as S, useTooltipModelToggle as x } from "./index687.js";
import { defineComponent as L, ref as l, toRef as f, computed as b, provide as z, unref as s, readonly as D, watch as M, onDeactivated as F, onBeforeUnmount as K, openBlock as c, createBlock as w, withCtx as v, createVNode as y, renderSlot as T, createCommentVNode as k, createElementBlock as C, toDisplayString as U } from "vue";
import { ElPopper as V } from "./index668.js";
import { TOOLTIP_INJECTION_KEY as J } from "./index691.js";
import Y from "./index756.js";
import j from "./index757.js";
import { usePopperContainer as q } from "./index708.js";
import { useDelayedToggle as G } from "./index690.js";
import Q from "./index557.js";
import { useNamespace as W } from "./index559.js";
import { useId as X } from "./index640.js";
import { isBoolean as Z } from "./index565.js";
const _ = ["innerHTML"], ee = { key: 1 };
var ue = /* @__PURE__ */ L({
  name: "ElTooltip",
  __name: "tooltip",
  props: S,
  emits: N,
  setup(e, { expose: A, emit: E }) {
    const o = e, i = E;
    q();
    const I = W("tooltip"), R = X(), d = l(), g = l(), h = () => {
      var t;
      const a = s(d);
      a && ((t = a.popperInstanceRef) == null || t.update());
    }, r = l(!1), n = l(), { show: B, hide: u, hasUpdateHandler: O } = x({
      indicator: r,
      toggleReason: n
    }), { onOpen: m, onClose: p } = G({
      showAfter: f(o, "showAfter"),
      hideAfter: f(o, "hideAfter"),
      autoClose: f(o, "autoClose"),
      open: B,
      close: u
    }), P = b(
      () => Z(o.visible) && !O.value
    ), $ = b(() => [I.b(), o.popperClass]);
    z(J, {
      controlled: P,
      id: R,
      open: D(r),
      trigger: f(o, "trigger"),
      onOpen: m,
      onClose: p,
      onToggle: (t) => {
        s(r) ? p(t) : m(t);
      },
      onShow: () => {
        i("show", n.value);
      },
      onHide: () => {
        i("hide", n.value);
      },
      onBeforeShow: () => {
        i("before-show", n.value);
      },
      onBeforeHide: () => {
        i("before-hide", n.value);
      },
      updatePopper: h
    }), M(
      () => o.disabled,
      (t) => {
        t && r.value && (r.value = !1);
      }
    );
    const H = (t) => {
      var a;
      return (a = g.value) == null ? void 0 : a.isFocusInsideContent(t);
    };
    return F(() => r.value && u()), K(() => {
      n.value = void 0;
    }), A({
      /**
       * @description el-popper component instance
       */
      popperRef: d,
      /**
       * @description el-tooltip-content component instance
       */
      contentRef: g,
      /**
       * @description validate current focus event is trigger inside el-tooltip-content
       */
      isFocusInsideContent: H,
      /**
       * @description update el-popper component instance
       */
      updatePopper: h,
      /**
       * @description expose onOpen function to mange el-tooltip open state
       */
      onOpen: m,
      /**
       * @description expose onClose function to manage el-tooltip close state
       */
      onClose: p,
      /**
       * @description expose hide function
       */
      hide: u
    }), (t, a) => (c(), w(s(V), {
      ref_key: "popperRef",
      ref: d,
      role: e.role
    }, {
      default: v(() => [
        y(Y, {
          disabled: e.disabled,
          trigger: e.trigger,
          "trigger-keys": e.triggerKeys,
          "virtual-ref": e.virtualRef,
          "virtual-triggering": e.virtualTriggering,
          "focus-on-target": e.focusOnTarget
        }, {
          default: v(() => [
            t.$slots.default ? T(t.$slots, "default", { key: 0 }) : k("v-if", !0)
          ]),
          _: 3
          /* FORWARDED */
        }, 8, ["disabled", "trigger", "trigger-keys", "virtual-ref", "virtual-triggering", "focus-on-target"]),
        y(j, {
          ref_key: "contentRef",
          ref: g,
          "aria-label": e.ariaLabel,
          "boundaries-padding": e.boundariesPadding,
          content: e.content,
          disabled: e.disabled,
          effect: e.effect,
          enterable: e.enterable,
          "fallback-placements": e.fallbackPlacements,
          "hide-after": e.hideAfter,
          "gpu-acceleration": e.gpuAcceleration,
          offset: e.offset,
          persistent: e.persistent,
          "popper-class": $.value,
          "popper-style": e.popperStyle,
          placement: e.placement,
          "popper-options": e.popperOptions,
          "arrow-offset": e.arrowOffset,
          pure: e.pure,
          "raw-content": e.rawContent,
          "reference-el": e.referenceEl,
          "trigger-target-el": e.triggerTargetEl,
          "show-after": e.showAfter,
          strategy: e.strategy,
          teleported: e.teleported,
          transition: e.transition,
          "virtual-triggering": e.virtualTriggering,
          "z-index": e.zIndex,
          "append-to": e.appendTo,
          loop: e.loop
        }, {
          default: v(() => [
            T(t.$slots, "content", {}, () => [
              e.rawContent ? (c(), C("span", {
                key: 0,
                innerHTML: e.content
              }, null, 8, _)) : (c(), C(
                "span",
                ee,
                U(e.content),
                1
                /* TEXT */
              ))
            ]),
            e.showArrow ? (c(), w(s(Q), { key: 0 })) : k("v-if", !0)
          ]),
          _: 3
          /* FORWARDED */
        }, 8, ["aria-label", "boundaries-padding", "content", "disabled", "effect", "enterable", "fallback-placements", "hide-after", "gpu-acceleration", "offset", "persistent", "popper-class", "popper-style", "placement", "popper-options", "arrow-offset", "pure", "raw-content", "reference-el", "trigger-target-el", "show-after", "strategy", "teleported", "transition", "virtual-triggering", "z-index", "append-to", "loop"])
      ]),
      _: 3
      /* FORWARDED */
    }, 8, ["role"]));
  }
});
export {
  ue as default
};
